import store from '../store';
import { createRouter, createWebHistory } from 'vue-router';
//import AuthService from '../services/AuthService';

// preload views
import Sign from '../views/Sign.vue';
import Signin from '../views/Signin.vue';
import Signup from '../views/Signup.vue';
import Recover from '../views/Recover.vue';
import ThinkHub from '../views/ThinkHub.vue';
//import Home from '../views/Home.vue';
import Error404 from '../views/Error404.vue';
import Course from '../views/Course.vue';

// load each view when route visited
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue');
//const Help = () => import(/* webpackChunkName: "help" */ '../views/Help.vue');
const Messages = () => import(/* webpackChunkName: "messages" */ '../views/Messages.vue');
const Calls = () => import(/* webpackChunkName: "calls" */ '../views/Calls.vue');
const Learn = () => import(/* webpackChunkName: "learn" */ '../views/Learn.vue');
const ManageLearning = () => import(/* webpackChunkName: "manageLearning" */ '../views/ManageLearning.vue');
const ManageLearningCourse = () => import(/* webpackChunkName: "manageLearningCourse" */ '../views/ManageLearningCourse.vue');
//const ManageLearningCoursePreview = () => import(/* webpackChunkName: "manageLearningCoursePreview" */ '../views/ManageLearningCoursePreview.vue');
const ManageLearningCourseContent = () => import(/* webpackChunkName: "manageLearningCourseContent" */ '../views/ManageLearningCourseContent.vue');
const ManageLearningCourseLesson = () => import(/* webpackChunkName: "manageLearningCourseLesson" */ '../views/ManageLearningCourseLesson.vue');
const ManageLearningCourseSettings = () => import(/* webpackChunkName: "manageLearningCourseSettings" */ '../views/ManageLearningCourseSettings.vue');
const ManageLearningCourseCertification = () => import(/* webpackChunkName: "manageLearningCourseCertification" */ '../views/ManageLearningCourseCertification.vue');
const ManageLearningCourseAccess = () => import(/* webpackChunkName: "manageLearningCourseAccess" */ '../views/ManageLearningCourseAccess.vue');
//const ManageLearningCoursePrerequisits = () => import(/* webpackChunkName: "manageLearningCoursePrerequisits" */ '../views/ManageLearningCoursePrerequisits.vue');
const ManageLearningCourseActivity = () => import(/* webpackChunkName: "manageLearningCourseActivity" */ '../views/ManageLearningCourseActivity.vue');
const ManageLearningCourseFeedback = () => import(/* webpackChunkName: "manageLearningCourseFeedback" */ '../views/ManageLearningCourseFeedback.vue');
const ManageMedia = () => import(/* webpackChunkName: "manageMedia" */ '../views/ManageMedia.vue');
const ManagePeople = () => import(/* webpackChunkName: "managePeople" */ '../views/ManagePeople.vue');
const ManagePeopleUser = () => import(/* webpackChunkName: "managePeopleUser" */ '../views/ManagePeopleUser.vue');
//const ManagePeopleUserOverview = () => import(/* webpackChunkName: "managePeopleUserOverview" */ '../views/ManagePeopleUserOverview.vue');
const ManagePeopleUserProfile = () => import(/* webpackChunkName: "managePeopleUserProfile" */ '../views/ManagePeopleUserProfile.vue');
const ManagePeopleUserAssignment = () => import(/* webpackChunkName: "managePeopleUserAssignment" */ '../views/ManagePeopleUserAssignment.vue');
//const ManagePeopleUserLearning = () => import(/* webpackChunkName: "managePeopleUserLearning" */ '../views/ManagePeopleUserLearning.vue');
const ManagePeopleUserActivity = () => import(/* webpackChunkName: "managePeopleUserActivity" */ '../views/ManagePeopleUserActivity.vue');
const ManageGroup = () => import(/* webpackChunkName: "manageGroup" */ '../views/ManageGroup.vue');
const ManageGroupAssignment = () => import(/* webpackChunkName: "manageGroupAssignment" */ '../views/ManageGroupAssignment.vue');
const ManageTheme = () => import(/* webpackChunkName: "manageTheme" */ '../views/ManageTheme.vue');
const ManageThemeStyle = () => import(/* webpackChunkName: "manageThemeStyle" */ '../views/ManageThemeStyle.vue');
const ManageThemeFont = () => import(/* webpackChunkName: "manageThemeFont" */ '../views/ManageThemeFont.vue');
const ManageThemeColour = () => import(/* webpackChunkName: "manageThemeColour" */ '../views/ManageThemeColour.vue');
const ManageThemeTerminology = () => import(/* webpackChunkName: "manageThemeTerminology" */ '../views/ManageThemeTerminology.vue');
//const ManageThemeCss = () => import(/* webpackChunkName: "manageThemeCss" */ '../views/ManageThemeCss.vue');
const ManageOrganisation = () => import(/* webpackChunkName: "manageOrganisation" */ '../views/ManageOrganisation.vue');
const ManageOrganisationSettings = () => import(/* webpackChunkName: "manageOrganisationSettings" */ '../views/ManageOrganisationSettings.vue');
const ManageOrganisationFeatures = () => import(/* webpackChunkName: "manageOrganisationFeatures" */ '../views/ManageOrganisationFeatures.vue');
//const ManageOrganisationBilling = () => import(/* webpackChunkName: "manageOrganisationBilling" */ '../views/ManageOrganisationBilling.vue');
const ManageAccount = () => import(/* webpackChunkName: "manageAccount" */ '../views/ManageAccount.vue');
const ManageAccountSettings = () => import(/* webpackChunkName: "manageAccountSettings" */ '../views/ManageAccountSettings.vue');
//const CourseSynopsis = () => import(/* webpackChunkName: "courseSynopsis" */ '../views/CourseSynopsis.vue');
const CourseProgress = () => import(/* webpackChunkName: "courseProgress" */ '../views/CourseProgress.vue');

const routes = [
	{
		path: '/',
		redirect: '/dashboard',
	},
	{
		path: '/', // unused
		name: 'Sign',
		component: Sign,
		meta: {
			requireLogin: false, // inherited by child routes
		},
		children: [
			{
				path: '/signup',
				name: 'Signup',
				component: Signup,
				meta: {},
			},
			{
				path: '/signin',
				name: 'Signin',
				component: Signin,
				meta: {},
			},
			{
				path: '/recover',
				name: 'Recover',
				component: Recover,
				meta: {},
			},
			{
				path: '', // default
				redirect: { name: 'Signin' }
			},
		]
	},
	{
		path: '/', // unused
		name: 'Course',
		component: Course,
		meta: {
			requireLogin: true, // inherited by child routes
		},
		children: [
			/*{
				path: '/:courseId/synopsis',
				name: 'CourseSynopsis',
				component: CourseSynopsis,
				meta: {},
			},*/
			{
				path: 'course/:courseId/lesson/:lessonId',
				name: 'CourseProgress',
				component: CourseProgress,
				meta: {},
			},
		],
	},
	{
		path: '/', // unused
		name: 'ThinkHub',
		component: ThinkHub,
		meta: {
			requireLogin: true, // inherited by child routes
		},
		children: [
			{
				path: '/dashboard',
				name: 'Dashboard',
				component: Dashboard,
				meta: {},
			},
			/*{
				path: '/help',
				name: 'Help',
				component: Help,
				meta: {},
			},*/
			{
				path: '/messages', // messenge management
				name: 'Messages',
				component: Messages,
				meta: { 
					feature: 'messages',
					subfeature: null,
				},
			},
			{
				path: '/calls', // zoom call management
				name: 'Calls',
				component: Calls,
				meta: { 
					feature: 'calls',
					subfeature: null,
				},
			},
			{
				path: '/learn',
				redirect: '/learn/active',
			},
			{
				path: '/learn/:state', // active or complete
				name: 'Learn',
				component: Learn,
				props: true,
				meta: {},
			},
			{
				path: '/manage/learning', // course list
				name: 'ManageLearning',
				component: ManageLearning,
				meta: { 
					feature: 'course',
					subfeature: null,
				},
			},
			{
				path: '/manage/learning/:courseId', // course parent
				name: 'ManageLearningCourse',
				component: ManageLearningCourse,
				meta: { 
					feature: 'course',
					subfeature: 'content',
				},
				children: [
					{
						path: 'content', // course content list + section management
						name: 'ManageLearningCourseContent',
						component: ManageLearningCourseContent,
						meta: { 
							feature: 'course',
							subfeature: 'content',
						},
					},
					{
						path: 'settings', // course setting management
						name: 'ManageLearningCourseSettings',
						component: ManageLearningCourseSettings,
						meta: {
							feature: 'course',
							subfeature: 'settings',
						},
					},
					{
						path: 'certification', // course certification management
						name: 'ManageLearningCourseCertification',
						component: ManageLearningCourseCertification,
						meta: {
							feature: 'course',
							subfeature: 'certification',
						},
					},
					{
						path: 'access', // course access management
						name: 'ManageLearningCourseAccess',
						component: ManageLearningCourseAccess,
						meta: {
							feature: 'course',
							subfeature: 'access',
						},
					},
					{
						path: 'activity', // course prerequisit management
						name: 'ManageLearningCourseActivity',
						component: ManageLearningCourseActivity,
						meta: {
							feature: 'course',
							subfeature: 'activity',
						},
					},
					{
						path: 'feedback', // course feedback management
						name: 'ManageLearningCourseFeedback',
						component: ManageLearningCourseFeedback,
						meta: {
							feature: 'course',
							subfeature: 'activity',
						},
					},
					{
						path: 'lesson/:lessonId', // course lession edit
						name: 'ManageLearningCourseLesson',
						component: ManageLearningCourseLesson,
						meta: {
							feature: 'course',
							subfeature: 'content',
						},
					},
				],
			},
			{
				path: '/manage/media', // media list + management
				name: 'ManageMedia',
				component: ManageMedia,
				meta: {
					feature: 'media',
					subfeature: null,
				},
			},
			{
				path: '/manage/people', // people list
				name: 'ManagePeople',
				component: ManagePeople,
				meta: {
					feature: 'people',
					subfeature: null,
				},
			},
			{
				path: '/manage/people/:userId', // individual
				name: 'ManagePeopleUser',
				component: ManagePeopleUser,
				meta: {
					feature: 'people',
					subfeature: null,
				},
				children: [
					/*{
						path: 'overview', // individual profile overview
						name: 'ManagePeopleUserOverview',
						component: ManagePeopleUserOverview,
						meta: {
							feature: 'people',
							subfeature: null,
						},
					},*/
					{
						path: 'profile', // individual profile management
						name: 'ManagePeopleUserProfile',
						component: ManagePeopleUserProfile,
						meta: {
							feature: 'people',
							subfeature: null,
						},
					},
					{
						path: 'assignment', // student/mentor assignment
						name: 'ManagePeopleUserAssignment',
						component: ManagePeopleUserAssignment,
						meta: {
							feature: 'people',
							subfeature: null,
						},
					},
					/*{
						path: 'learning', // individual learning management
						name: 'ManagePeopleUserLearning',
						component: ManagePeopleUserLearning,
						meta: {
							feature: 'people',
							subfeature: null,
						},
					},*/
					{
						path: 'activity', // individual activity
						name: 'ManagePeopleUserActivity',
						component: ManagePeopleUserActivity,
						meta: {
							feature: 'people',
							subfeature: null,
						},
					},
				],
			},
			{
				path: '/manage/group', // group list
				name: 'ManageGroup',
				component: ManageGroup,
				meta: {
					feature: 'group',
					subfeature: null,
				},
//				children: [
//				],
			},
			{
				path: '/manage/group/:groupId/assignment', // group assignment
				name: 'ManageGroupAssignment',
				component: ManageGroupAssignment,
				meta: {
					feature: 'group',
					subfeature: null,
				},
			},
			{
				path: '/manage/organisation', // individual
				name: 'ManageOrganisation',
				component: ManageOrganisation,
				meta: {
					feature: 'organisation',
					subfeature: null,
				},
				children: [
					{
						path: 'feature',
						name: 'ManageOrganisationFeatures',
						component: ManageOrganisationFeatures,
						meta: {
							feature: 'organisation',
							subfeature: 'features',
						},
					},
					{
						path: 'settings',
						name: 'ManageOrganisationSettings',
						component: ManageOrganisationSettings,
						meta: {
							feature: 'organisation',
							subfeature: 'settings',
						},
					},
					/*{
						path: 'billing',
						name: 'ManageOrganisationBilling',
						component: ManageOrganisationBilling,
						meta: {
							feature: 'organisation',
							subfeature: 'billing',
						},
					},*/
				],
			},
			{
				path: '/manage/account', // individual
				name: 'ManageAccount',
				component: ManageAccount,
				meta: {
					feature: 'account',
					subfeature: null,
				},
				children: [
					{
						path: 'profile',
						name: 'ManageAccountProfile',
						component: ManagePeopleUserProfile, // reused
						meta: {
							feature: 'account',
							subfeature: 'profile',
						},
					},
					{
						path: 'assignment', // student/mentor assignment
						name: 'ManageAccountUserAssignment',
						component: ManagePeopleUserAssignment, // reused
						meta: {
							feature: 'account',
							subfeature: null,
						},
					},
					{
						path: 'settings',
						name: 'ManageAccountSettings',
						component: ManageAccountSettings,
						meta: {
							feature: 'account',
							subfeature: 'settings',
						},
					},
				],
			},
			{
				path: '/manage/theme', // individual
				name: 'ManageTheme',
				component: ManageTheme,
				meta: {
					feature: 'theme',
					subfeature: null,
				},
				children: [
					{
						path: 'style',
						name: 'ManageThemeStyle',
						component: ManageThemeStyle,
						meta: {
							feature: 'theme',
							subfeature: 'style',
						},
					},
					{
						path: 'font',
						name: 'ManageThemeFont',
						component: ManageThemeFont,
						meta: {
							feature: 'theme',
							subfeature: 'font',
						},
					},
					{
						path: 'colour',
						name: 'ManageThemeColour',
						component: ManageThemeColour,
						meta: {
							feature: 'theme',
							subfeature: 'colour',
						},
					},
					{
						path: 'terminology',
						name: 'ManageThemeTerminology',
						component: ManageThemeTerminology,
						meta: {
							feature: 'theme',
							subfeature: 'terminology',
						},
					},
				],
			},
		]
	},
	{ // page not found
		path: '/:pathMatch(.*)*',
		name: 'Error404',
		component: Error404,
		meta: {},
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
/*	scrollBehavior() {
		// always scroll to top
//		return {
//			top: 0,
//		}
		return new Promise((resolve) => {
			setTimeout(() => {
				resolve({ top: 0 });
			}, 600);
		});
	},*/
});

// navigation guards
router.beforeEach( async (to, from, next) => {
	// initiate gui if not already done
	if (!store.state.gui.orgInitiated) {
		await store.dispatch('gui/initOrganisation');		
	}
	
	// auth status checks
	if (!store.state.auth.checked) {
		// auth status unset, so check if user is logged in
		await store.dispatch('auth/status');
		
	} else {
		// check for session expiry
		await store.dispatch('auth/session');
		//console.log('session expired:', expired);
	}
	
	// check requested route requires user to be logged in
	const requireLogin = to.matched.some(record => record.meta.requireLogin);
	
	if (requireLogin && !store.state.auth.loggedIn && to.name !== 'Signin') {
		// enforce sign in
		next({name:'Signin'});
	
	} else if (store.state.auth.loggedIn && !store.state.auth.user.verified && to.name !== 'ManageAccountSettings' && !(to.name === 'Signin' && to.params.signout)){
		// ensure password is set and if non-email user, password recovery info
		next({name:'ManageAccountSettings'});
	
	} else if (store.state.auth.loggedIn && ((to.name === 'Signin' && !to.params.signout) || to.name === 'Signup')) {
		// already signed in
		next({name:'Dashboard'});
		
	} else if (store.state.auth.loggedIn && to.meta.feature && !store.getters['gui/hasFeature'](to.meta.feature, to.meta.subfeature)) {
//console.log('feature:',  to.meta.feature, to.meta.subfeature);
		if (to.meta.feature === 'people' && to.name === 'ManagePeople') {
			// allow access to the user list but restrict in-page management and individual profile access
			next();
			
		} else {
			// user role doesn't have feature/subfeature access
			next({name:'Error404'});			
		}
		// user role doesn't have feature/subfeature access
//		next({name:'Error404'});
		
	} else {
		next();
	}
});

export default router;
